import { Grid } from "@mui/material"
import { useSelector } from "react-redux"

import { useTranslation } from "react-i18next"
import { RootState } from "../../../store"
import { PlicksListState, PlickState } from "../../../store/actions/file-detail"
import NoData from "../../error/nodata"
import PlickCard from "./card"

const PlickListComponent = () => {
	const { t } = useTranslation()
	const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
	const itemsShowned = useSelector(
		(state: RootState) =>
			(state.plicks?.list?.page?.number + 1) *
			state.plicks?.list?.page?.numberOfElements
	)

	const totalItems = useSelector(
		(state: RootState) => state.plicks?.list?.page?.totalElements
	)

	const isMore = useSelector(
		(state: RootState) => !!state.plicks?.list?.nextUrl
	)

	const plicksState: PlicksListState = useSelector(
		(state: RootState) => state.plicks
	)

	return (
		<>
			<Grid container flexWrap={"wrap"} alignContent={"space-between"}>
				{plicksState?.list?.page?.content.map((currentPlick: PlickState) => {
					return (
						<PlickCard
							key={`plick_${currentPlick?.id}`}
							plickInfo={currentPlick}
							userTimeZone={userTimeZone}
						/>
					)
				})}
				{plicksState?.list?.page?.content?.length === 0 && <NoData />}
			</Grid>
			<Grid
				container
				justifyContent="space-between"
				style={{ backgroundColor: "#FFF", fontWeight: "600", padding: "16px" }}
			>
				<Grid item> </Grid>
				<Grid item>{isMore ? t("loadMore", { ns: "common" }) : ""}</Grid>
				<Grid item>
					{itemsShowned} {t("of", { ns: "common" })} {totalItems}
				</Grid>
			</Grid>
		</>
	)
}

export default PlickListComponent
